import { render, staticRenderFns } from "./demoEndingModal.vue?vue&type=template&id=5c901796&scoped=true"
import script from "./demoEndingModal.vue?vue&type=script&lang=js"
export * from "./demoEndingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c901796",
  null
  
)

export default component.exports